import { Component, ElementRef, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import Talk from 'talkjs';

import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { ChatService } from '../../services/chat/chat.service';

@Component({
  selector: 'app-inbox',
  standalone: true,
  imports: [],
  templateUrl: './inbox.component.html',
  styleUrl: './inbox.component.css',
})
export class InboxComponent implements OnInit, OnDestroy {
  private talkService = inject(ChatService);
  auth = inject(AuthService);

  chatbox!: Talk.Chatbox;
  private session!: Talk.Session;
  @ViewChild('talkjsContainer') talkjsContainer!: ElementRef;

  ngOnInit(): void {
   this.createInbox();
  }

  private async createInbox(user?: any) {
    const session = await this.talkService.createCurrentSession();
    this.chatbox = await this.talkService.createInbox(session);
    this.chatbox.mount(this.talkjsContainer.nativeElement);
  }

  ngOnDestroy() {
    if (this.chatbox) {
      this.chatbox.destroy();
    }
  }
}
